module.exports = __webpack_public_path__ + "static/img/68 (3).74add96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/68 (3).jpg
// module id = GUd6
// module chunks = 0